
<template>
    <section id="creditanalysis" v-if="userStore.user">
        <div id="section-block" class="page-blockui">
            <div class="row" id="credit_scores_step">
                <div class="col-xl-12 col-md-12 col-12 mx-auto">
                    <power-of-attorney/>
                </div>
            </div>
        </div>
        <credit-analysis :client-email='userStore.user.email'></credit-analysis>
    </section>
</template>
<script>
    import PowerOfAttorney from "./PowerOfAttorney.vue"
    import {ref} from 'vue';
    import { useClientStore } from "../../stores/ClientStore.js";
    import { useUserStore } from "../../stores/UserStore.js";
    export default {
        components: {
            PowerOfAttorney
        },
        setup(){
            return{
                clientStore : useClientStore(),
                userStore : useUserStore(),
                email:ref(null)
            }
        },
        mounted(){
            if(!_.isNull(this.userStore.user)){
                this.email = this.userStore.user.email
            }
        },
        methods:{
        }
    }
</script>
